import { connectionState } from 'connection-state';
import { useState, useEffect } from 'react';

var createUseConnectionStateHook = function (options) {
    var connection = connectionState(options);
    var getState = function () { return connection.getState(); };
    var useConnectionState = function () {
        var _a = useState(function () { return getState(); }), state = _a[0], setState = _a[1];
        useEffect(function () {
            var refresh = function () {
                setState(getState());
            };
            refresh();
            connection.addListener(refresh);
            return function () {
                connection.removeListener(refresh);
            };
        }, []);
        return state;
    };
    return useConnectionState;
};

var useConnectionState = createUseConnectionStateHook();

export { createUseConnectionStateHook, useConnectionState };
//# sourceMappingURL=index.es.js.map
